/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiAppNOTI } from 'api/request';
import urlApp from 'api/urlApp';
import { size } from 'lodash';
import HttpRequestError from 'utils/HttpRequetsError';

export async function getListNotiAPI(payload: any): Promise<any> {
  const {data} = await apiAppNOTI.get(urlApp.getListNotiPath, {params: payload});
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getCountNotiAPI(payload: any): Promise<any> {
  const {data} = await apiAppNOTI.get(urlApp.getCountNotiPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function updateStatusNotiAPI(payload: any): Promise<any> {
  const {data} = await apiAppNOTI.put(`${urlApp.updateStatusNoti}/${payload}`);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getDetailNotiAPI(payload: any): Promise<any> {
  const {data} = await apiAppNOTI.get(`${urlApp.detailNotiPath}/${payload}`);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}